import { Component, Input, signal } from '@angular/core';
import { FrameworkColumn, ITableCellValueRenderer } from '@pf/shared-common';
import { IItemFragment } from '@pf/shared/util-platform';
import { UntilDestroy } from '@ngneat/until-destroy';
import { CpwItemLocationPathComponent } from './cpw-item-location-path.component';
import { ContainerFragment, SlotFragment } from '@control-tower/platform-wms';

@UntilDestroy()
@Component({
    selector: 'cpw-item-location-path-renderer',
    template: `<cpw-item-location-path
        [segmented]="false"
        [slot]="value"
        [container]="container"
        chipStatus="primary"></cpw-item-location-path>`,
    styles: [
        `
            :host {
                display: block;
            }
        `,
    ],
    standalone: true,
    imports: [CpwItemLocationPathComponent],
})
export class CpwItemLocationPathRendererComponent
    implements ITableCellValueRenderer
{
    container?: ContainerFragment;
    @Input() value!: SlotFragment | null | undefined;
    @Input() column!: FrameworkColumn;
    @Input() set row(
        record: { container?: ContainerFragment } | undefined | null
    ) {
        this.container = record?.container;
    }

    item = signal<IItemFragment | null | undefined>(null);
}
